import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import { getImageLocal } from '@/utils/locals';
import TextModule from '@/components/ProductDetailComponents/TextModule';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import TextWithImage from '@/components/ProductDetailComponents/TextWithImage';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointDeltaBase from '@/components/AppPoint/DeltaBasePC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const webpUrl = '/media/deltamini/pc/';
const { EFPic } = createEFPic(webpUrl);

export default function IndexDynamic() {
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const { t } = useLang('delta_mini_new');

    const text3 = {
        text: t('AC_output'),
    };

    const text4 = {
        text: t('AC_output_sub_title'),
    };

    const text5 = {
        text: t.rich('AC_output_desc', {
            line1: (text: string) => (
                <Link className="ef-link__page" href="/x-boost" newWin>
                    {`\u000A${text}`}
                </Link>
            ),
        }),
        useHtmlAttr: true,
    };

    const text6 = {
        text: t('AC_output_notice'),
    };

    const text7 = {
        text: t('capacity'),
    };

    const text8 = {
        text: t('capacity_sub_title'),
    };

    const text9 = {
        text: t('capacity_desc'),
    };

    const text10 = {
        text: t('portable_design'),
    };

    const text11 = {
        text: t('portable_design_sub_title'),
    };

    const text12 = {
        text: t('portable_design_desc'),
    };

    const textStyle2 = {
        textAlign: 'center',
        backColor: 'transparent',
        margin: '0 auto',
        lineHeight: '40px',
        fontSize: '32px',
        color: '#fff',
        fontFamily: 'var(--font-family-Medium)',
        fontWeight: 500,
    };

    const textStyle3 = {
        type: 'ls',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#fff',
        margin: '10px auto 40px',
    };

    const textStyle4 = {
        width: '924px',
        fontSize: locale === 'jp' ? '21px' : '22px',
        lineHeight: '1.55',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#999',
        margin: '10px auto 40px',
    };

    const textStyle41 = {
        width: '924px',
        fontSize: '22px',
        lineHeight: '1.55',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#999',
    };

    const textStyle5 = {
        width: '48%',
        fontSize: '17px',
        opacity: 1,
        lineHeight: '1.55',
        color: '#777',
        textAlign: 'center',
        margin: '0 auto',
        backColor: 'transparent',
    };

    const unitHrsForLang = {
        us: 'h',
        jp: '時間',
        de: 'Stunde',
        cn: '时',
    };

    const item1 = {
        title: '',
        synopsis: t('fastest_charging'),
        desc: t('fastest_charging_desc'),
        bgImgs: ['4_main.webp', '4_main.jpg'],
        icon: '/media/deltamini/pc/4_main_icon.png',
        newWindLink: '/x-stream',
        linkDesc: t('x_stream_link'),
        arr: [
            {
                num: 900,
                eum: 'w',
                desc: t('fastest_charging_desc1'),
                phrase: t('fastest_charging_desc3'),
            },
            {
                num: 1,
                eum: unitHrsForLang[locale as keyof typeof unitHrsForLang] || unitHrsForLang.us,
                desc: t('fastest_charging_desc2'),
            },
        ],
    };

    const item2 = {
        img_url: ['6_main.webp', '6_main.jpg'],
        title: t('solar_input'),
        synopsis: t('solar_input_sub_title'),
        desc: t('solar_input_desc'),
        phrase: t.raw('solar_input_notice'),
    };

    const item3 = {
        title: t('battery_system'),
        synopsis: t('battery_system_sub_title'),
        desc: t('battery_system_desc'),
        bgImgs: ['8_main.webp', '8_main.png'],
    };
    const item4 = {
        title: t('app_support'),
        synopsis: t('app_support_sub_title'),
        desc: t('app_support_desc'),
        bgImgs: [`9_main_${appImgLocal}.webp`, `9_main_${appImgLocal}.png`],
    };

    const titleFontSize = {
        us: 64,
        jp: 40,
        de: 59,
        es: 58,
    };

    return (
        <>
            <LineSpace height={175} background="transparent" />
            <div className="section2">
                <div className="left">
                    <div className="top box">
                        <EFPic name={['DELTA MINI_web_2.png', 'DELTA MINI_web_2.webp']} alt={t('second_lightweight')} aria-label={t('second_lightweight')} />
                        <p className="num">{t('second_lightweight_value')}</p>
                        <p className="tit">{t('second_lightweight')}</p>
                    </div>
                    <div className="bottom box">
                        <EFPic
                            name={['DELTA MINI_web_3.webp', 'DELTA MINI_web_3.png']}
                            alt={t('second_fast_charging')}
                            aria-label={t('second_fast_charging')}
                        />
                        <p className="tit">{t('second_fast_charging_value')}</p>
                        <p className="num">{t('second_fast_charging')}</p>
                    </div>
                </div>
                <div className="middle box">
                    <EFPic name={['DELTA MINI_web_1.webp', 'DELTA MINI_web_1.png']} alt={t('second_ac_output')} aria-label={t('second_ac_output')} />
                    <p className="tit">
                        {t('second_ac_output_value')}
                        <br />
                        {t('second_ac_output')}
                    </p>
                </div>
                <div className="right">
                    <div className="top box">
                        <EFPic name={['DELTA MINI_web_5.webp', 'DELTA MINI_web_5.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <p className="num">{t('second_capacity_value')}</p>
                        <p className="tit">{t('second_capacity')}</p>
                    </div>
                    <div className="middle box">
                        <EFPic name={['DELTA MINI_web_6.png', 'DELTA MINI_web_6.webp']} alt={t('second_solar_input')} aria-label={t('second_solar_input')} />
                        <p className="num">{t('second_solar_input_value')}</p>
                        <p className="tit">{t('second_solar_input')}</p>
                    </div>
                    <div className="bottom">
                        <div className="rb-left box">
                            <EFPic
                                name={['DELTA MINI_web_7.webp', 'DELTA MINI_web_7.png']}
                                alt={t('second_safe_use_with_value')}
                                aria-label={t('second_safe_use_with_value')}
                            />
                            <p className="tit">{t('second_safe_use_with')}</p>
                            <p className="num">{t('second_safe_use_with_value')}</p>
                        </div>
                        <div className="rb-right box">
                            <EFPic
                                name={['DELTA MINI_web_4.webp', 'DELTA MINI_web_4.png']}
                                alt={t('second_easy_control')}
                                aria-label={t('second_easy_control')}
                            />
                            <p className="tit">{t('second_easy_control')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <LineSpace height={30} background="transparent" />
            <LineSpace height={120} background="transparent" />
            <TextModule data={text3} cssStyle={textStyle2} />
            <TextModule data={text4} cssStyle={textStyle3} />
            <div className="textModule1">
                <TextModule
                    data={text5}
                    cssStyle={{
                        ...textStyle4,
                        width: locale === 'cn' ? '700px' : locale === 'sa' ? '810px' : '924px',
                        letterSpacing: '-0.1px',
                    }}
                />
                <TextModule data={text6} cssStyle={textStyle5} />
            </div>
            <LineSpace height={80} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '800px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['3_main.webp', '3_main.jpg']} className="fullImgs" alt={t('1400W AC Output')} />
            </div>
            <LineSpace height={80} background="transparent" />
            <div className="textOnImg2">
                <TextOnImage
                    data={item1}
                    config={{
                        position: locale != 'sa' ? 'left' : 'right',
                        titleColor: '#ededed',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        itemsDescColor: '#919191',
                        itemsPhraseColor: '#919191',
                        synopsisFontSize: titleFontSize[locale as keyof typeof titleFontSize] || titleFontSize.us,
                        descFontSize: '22',
                        iconWidth: '115',
                        iconHeight: '33',
                        itemsColor: '#fff',
                        imgHeight: '900px',
                        isWebp: true,
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={80} background="transparent" />
            <TextModule data={text7} cssStyle={textStyle2} />
            <TextModule data={text8} cssStyle={textStyle3} />
            <LineSpace height={10} background="transparent" />
            <TextModule data={text9} cssStyle={textStyle41} />
            <LineSpace height={90} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '1080px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['5_main.webp', '5_main.jpg']} className="fullImgs" alt={t('882Wh Capacity')} />
            </div>
            <LineSpace height={90} background="transparent" />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <TextWithImage
                    data={item2}
                    config={{
                        padding: '180px 0',
                        position: 'right',
                        titleColor: '#fff',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        phraseColor: 'rgba(145, 145, 145)',
                        isWebp: true,
                        webpUrl,
                        synopsisFontSize: (() => {
                            const map = {
                                it: '52',
                                jp: '53',
                            };
                            return map[locale as keyof typeof map] || '64';
                        })(),
                        descFontSize: (() => {
                            const map = {
                                it: '19',
                            };
                            return map[locale as keyof typeof map] || '22';
                        })(),
                        phraseFontSize: (() => {
                            const map = {
                                it: '16',
                            };
                            return map[locale as keyof typeof map] || '17';
                        })(),
                    }}
                />
            </div>
            <LineSpace height={30} background="transparent" />
            <TextModule data={text10} cssStyle={textStyle2} />
            <TextModule data={text11} cssStyle={textStyle3} />
            <TextModule data={text12} cssStyle={textStyle4} />
            <LineSpace height={50} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '1280px',
                    height: '720px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['7_main.webp', '7_main.jpg']} className="fullImgs" alt={t('Portable Design')} />
            </div>
            <LineSpace height={230} background="transparent" />
            <div className="textOnImg1">
                <TextOnImage
                    data={item3}
                    config={{
                        position: 'top',
                        titleColor: '#ededed',
                        synopsisColor: '#fff',
                        descColor: '#f6f6f8',
                        titleFontSize: '32',
                        isWebp: true,
                        webpUrl,
                        synopsisFontSize: (() => {
                            const mapSize = {
                                de: 60,
                                es: 54,
                            };
                            type Astype = keyof typeof mapSize;
                            return mapSize[locale as Astype] || '64';
                        })(),
                        descFontSize: '22',
                        opacity: '0.6',
                    }}
                />
            </div>
            <LineSpace height={180} background="transparent" />

            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <TextOnImage
                    data={item4}
                    config={{
                        position: locale == 'sa' ? 'right' : 'left',
                        titleColor: '#fff',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        synopsisFontSize: locale === 'jp' ? '53' : '64',
                        isWebp: true,
                        webpUrl,
                        descFontSize: (() => {
                            const map = {
                                it: '22',
                            };
                            return map[locale as keyof typeof map] || '22';
                        })(),
                        width: (() => {
                            const map = {
                                it: '500px',
                            };
                            return map[locale as keyof typeof map] || '550px';
                        })(),
                    }}
                />
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointDeltaBase />}
            <LineSpace height={270} background="transparent" />
            <OtherList
                theme="black"
                data={getDetaileMoreProducts(gloproductlist, ['product_ps_delta_delta_1300', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'])}
            />
        </>
    );
}
